import { render, staticRenderFns } from "./CadastroCertificadoAssinatura.vue?vue&type=template&id=f00b4bac&scoped=true"
import script from "./CadastroCertificadoAssinatura.vue?vue&type=script&lang=js"
export * from "./CadastroCertificadoAssinatura.vue?vue&type=script&lang=js"
import style0 from "./CadastroCertificadoAssinatura.vue?vue&type=style&index=0&id=f00b4bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00b4bac",
  null
  
)

export default component.exports